import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './watchAction.css';
import { useSelector } from 'react-redux';

const WatchAction = () => {
  const store = useSelector((store) => store.data.HomeData);
  const [video, setVideo] = useState(null);

  useEffect(() => {
    const videoData = store?.items?.find(ele => ele.Section === 'Video');
    if (videoData) {
      setVideo(videoData.Content.URL);
    }
  }, [store]);

  const isYouTubeUrl = video?.includes('youtube.com') || video?.includes('youtu.be');

  return (
    <div className="watch-action-page-wrapper">
      <motion.h2 
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="heading1 capitalize-first-letter"
      >
        Watch our drones in action!
      </motion.h2>

      <div className="cards-container1">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {video && isYouTubeUrl ? (
            <div className="video-wrapper">
              <iframe
                src={convertToEmbedURL(video)}
                title="YouTube video"
                className="youtube-iframe"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ border: 'none', backgroundColor: 'transparent' }}
              ></iframe>
            </div>
          ) : video ? (
            <video width="100%" height="auto" controls>
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : null}
        </motion.div>
      </div>
    </div>
  );
};

// Helper to convert YouTube link to embed format
function convertToEmbedURL(url) {
  const idMatch = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
  const videoId = idMatch ? idMatch[1] : '';
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`;
}

export default WatchAction;
